import { IOptionProps } from "@blueprintjs/core";
import { getIn } from "formik";
import { FGCustomPanel, FGEmpty, FGSelectInput, FGTextInput, FieldGroup, FieldSet } from "nsitools-react";
import * as React from "react";

import { ERequestState } from "../../../api";
import { FGSRSHDateMaskInput, SmallFormGenerator } from "../../../components";
import { DrupalStepperButtonBloc } from "../../../drupal/common";
import { useTl } from "../../../hooks";
import { useReferential } from "../../../hooks/useReferential";
import { ETLCodes } from "../../../locales";
import { RequestBreedTransientSelection } from "../request/item/RequestBreedTransientSelection";

export interface IDrupalNewKennelRequestFormProps {
  newKennelRequestId: number;
  initialdata: any;
  loading: boolean;
}

export const DrupalNewKennelRequestForm: React.FunctionComponent<IDrupalNewKennelRequestFormProps> = ({
  newKennelRequestId,
  loading,
  initialdata,
}) => {
  const { t } = useTl();
  const [kennelTypes, ktloading] = useReferential((a) => a.getKennelTypes(), false, []);

  const [transientOwnerError] = React.useState(false);

  const generateNameOfferList = React.useCallback((formik) => {
    const names = [];
    for (let index = 1; index < 6; index++) {
      const element = getIn(formik?.values, `nameOffer${index}`);
      if (element) {
        names.push(element);
      }
    }
    return names?.map((p) => {
      return { value: p, label: p };
    }) as IOptionProps[];
  }, []);

  return (
    <SmallFormGenerator
      initialValues={initialdata}
      editMode={false}
      onSubmit={() => {}}
      loading={loading}
      saving={false}
      deleting={false}
      hideButtons
    >
      <FieldGroup
        columns={2}
        fieldsetProps={{
          title: t(ETLCodes.RequestData),
        }}
      >
        <div>
          <FGSRSHDateMaskInput name="request.requestDate" label={t(ETLCodes.RequestDate)} />
          {initialdata?.request?.status === ERequestState.EXECUTED && (
            <FieldGroup columns={2}>
              <FGSRSHDateMaskInput name="request.executionDate" label={t(ETLCodes.ClosingDate)} />
            </FieldGroup>
          )}
        </div>
      </FieldGroup>
      <FieldSet title={t(ETLCodes.FileAffix)}>
        <FieldGroup columns={2}>
          <FGTextInput name="nameOffer1" label={t(ETLCodes.NameOffer1)} maxLength={29} forceCase={"upper"} />
          <FGSelectInput name="nameOffer1Type" label={t(ETLCodes.Affix)} items={kennelTypes} loading={ktloading} />
          <FGTextInput name="nameOffer2" label={t(ETLCodes.NameOffer2)} maxLength={29} forceCase={"upper"} />
          <FGSelectInput name="nameOffer2Type" label={t(ETLCodes.Affix)} items={kennelTypes} loading={ktloading} />
          <FGTextInput name="nameOffer3" label={t(ETLCodes.NameOffer3)} maxLength={29} forceCase={"upper"} />
          <FGSelectInput name="nameOffer3Type" label={t(ETLCodes.Affix)} items={kennelTypes} loading={ktloading} />
          <FGTextInput name="nameOffer4" label={t(ETLCodes.NameOffer4)} maxLength={29} forceCase={"upper"} />
          <FGSelectInput name="nameOffer4Type" label={t(ETLCodes.Affix)} items={kennelTypes} loading={ktloading} />
          <FGTextInput name="nameOffer5" label={t(ETLCodes.NameOffer5)} maxLength={29} forceCase={"upper"} />
          <FGSelectInput name="nameOffer5Type" label={t(ETLCodes.Affix)} items={kennelTypes} loading={ktloading} />
        </FieldGroup>
      </FieldSet>
      <FieldSet title={t(ETLCodes.Owners)}>
        <FGCustomPanel>
          {({ formik }) => (
            <>
              {!transientOwnerError && initialdata?.request?.status === ERequestState.REQUESTED && (
                <FieldGroup columns={3}>
                  <FGEmpty />
                  <FGCustomPanel>
                    {(ctx) => (
                      <div style={{ color: "RED" }}>
                        <i className="fas fa-exclamation-triangle" />
                        {t(ETLCodes.AtLeastOneOwnerIsNotBelgian)}
                      </div>
                    )}
                  </FGCustomPanel>
                  <FGEmpty />
                </FieldGroup>
              )}
              {/* <RequestTransientPersonSelection
                linkedIds={formik?.values?.transientOwnerIds || null}
                onLinkedIdsChanged={(ids) => formik?.setFieldValue("transientOwnerIds", ids)}
                editMode={false}
                loading={loading}
              /> */}
            </>
          )}
        </FGCustomPanel>
      </FieldSet>
      <FieldSet title={t(ETLCodes.Breeds)}>
        <FGCustomPanel>
          {({ formik }) => (
            <>
              <RequestBreedTransientSelection
                linkedIds={formik?.values?.transientBreedIds || null}
                onLinkedIdsChanged={(ids) => formik?.setFieldValue("transientBreedIds", ids)}
                editMode={false}
                loading={loading}
              />
            </>
          )}
        </FGCustomPanel>
      </FieldSet>
      {(initialdata?.request?.status === ERequestState.TO_EVALUATE_FCI ||
        initialdata?.request?.status === ERequestState.EXECUTED) && (
        <FieldSet title={t(ETLCodes.FCIDecision)}>
          <FGCustomPanel>
            {(ctx) => {
              return (
                <FGSelectInput
                  name="finalName"
                  label={t(ETLCodes.FinalName)}
                  items={generateNameOfferList(ctx.formik)}
                  loading={ktloading}
                />
              );
            }}
          </FGCustomPanel>
          <FGTextInput name="finalType" label={t(ETLCodes.FinalAffix)} />
          <FGTextInput name="fciNumber" label={t(ETLCodes.FciNumber)} />
        </FieldSet>
      )}
      <DrupalStepperButtonBloc backOnly />
    </SmallFormGenerator>
  );
};
